import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"


import Default from "@/components/certificate/layouts/Default.vue";
import DevSecOps from "@/components/certificate/layouts/DevSecOps.vue";
import WebHackingNaPratica from "@/components/certificate/layouts/WebHackingNaPratica.vue";
import Redphish from "@/components/certificate/layouts/Redphish.vue";
import HackingParaIniciantes from "./layouts/HackingParaIniciantes.vue";
import InfraestruturaCloudSecurity from "@/components/certificate/layouts/InfraestruturaCloudSecurity.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  certificate: {}
},
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  const _component_ReportHacking = _resolveComponent("ReportHacking")!

  return (props.certificate?.course_id === 1)
    ? (_openBlock(), _createBlock(WebHackingNaPratica, {
        key: 0,
        certificate: props.certificate
      }, null, 8, ["certificate"]))
    : (props.certificate?.course_id === 30)
      ? (_openBlock(), _createBlock(DevSecOps, {
          key: 1,
          certificate: props.certificate
        }, null, 8, ["certificate"]))
      : (props.certificate?.course_id === 29)
        ? (_openBlock(), _createBlock(Redphish, {
            key: 2,
            certificate: props.certificate
          }, null, 8, ["certificate"]))
        : (props.certificate?.course_id === 22)
          ? (_openBlock(), _createBlock(HackingParaIniciantes, {
              key: 3,
              certificate: props.certificate
            }, null, 8, ["certificate"]))
          : (props.certificate?.course_id === 23)
            ? (_openBlock(), _createBlock(InfraestruturaCloudSecurity, {
                key: 4,
                certificate: props.certificate
              }, null, 8, ["certificate"]))
            : (props.certificate?.course_id === 27)
              ? (_openBlock(), _createBlock(_component_ReportHacking, {
                  key: 5,
                  certificate: props.certificate
                }, null, 8, ["certificate"]))
              : (_openBlock(), _createBlock(Default, {
                  key: 6,
                  certificate: props.certificate
                }, null, 8, ["certificate"]))
}
}

})